import React from 'react';
import {
	Page,
	Text,
	View,
	Font,
	Document,
	StyleSheet,
} from '@react-pdf/renderer';

import roboto from '../../../assets/fonts/Roboto-Light.ttf';
import robotoBold from '../../../assets/fonts/Roboto-Bold.ttf';

const styles = StyleSheet.create({
	tr: {
		flexDirection: 'row',
	},
	th: {
		fontSize: 10,
		borderBottom: 0.5,
		padding: 3,
		margin: 3,
		fontFamily: 'Roboto',
		fontWeight: 'bold'
	},
	td: {
		fontSize: 10,
		borderBottom: 0.5,
		padding: 3,
		margin: 3,
	},
	body: {
		paddingTop: 35,
		paddingBottom: 65,
		paddingHorizontal: 35,
		fontFamily: 'Roboto'
	},
	header: {
		fontSize: 16,
		marginBottom: 10,
		textAlign: 'left',
	},
	pageNumber: {
		position: 'absolute',
		fontSize: 12,
		bottom: 30,
		left: 0,
		right: 0,
		textAlign: 'center',
		color: 'grey',
	},
});


Font.register({
	family: 'Roboto',
	fonts: [{
		src: roboto,
	},{
		src: robotoBold,
		fontWeight: 'bold'
	}]
});


const PdfContent = ({ data, title }) => {

	return (
		<Document>
			<Page style={styles.body}>
				<Text style={styles.header}>
					{title}
				</Text>

				<View>
					<View style={styles.tr}>
						{data[0] && Object.keys(data[0]).map((key) => (
							<Text style={{ ...styles.th, width: `${key === 'LP.' ? '11%' : '40%'}` }} key={key}>{key}</Text>
						))}
					</View>

					{data.map((item, i) => (
						<View style={styles.tr} key={i}>
							{Object.keys(item).map((key) => (
								<Text style={{ ...styles.td, width: `${key === 'LP.' ? '11%' : '40%'}` }} key={key}>{item[key]}</Text>
							))}
						</View>
					))}
				</View>

				<Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
					`${pageNumber} / ${totalPages}`
				)} fixed />
			</Page>
		</Document>
	);
};

export default PdfContent;
